import React, { useState } from 'react';
import { Grid, TextField, InputAdornment } from '@material-ui/core';
import { get } from 'lodash';
import { List, ListItem } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import SlaIcon from 'images/time.svg';
import warning from 'images/warningoutlined.svg';
import timerDot from 'images/timerDot.svg';
import personIcon from 'images/person.svg';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import {
  StyledTitle,
  StyledListItem,
  StyledList,
  StyledField,
  SelectedStyledListItem,
  StyledSlaContainer,
  StyledWarningContainer,
  StylePendingContainer,
  StyleSecondaryContainer,
} from 'containers/AttributionManager/styles';
import SearchIcon from 'images/search.svg';
import {
  countManagersInboxes,
  countPendingClaimsInboxe,
  countTimeInboxes,
} from 'containers/AttributionManager/utils';
import { INBOXES_TYPES } from 'containers/AttributionManager/constants';

export interface ManagerInboxesProps {
  intl: IntlShape;
  listings: any;
  setSelectedInboxe: Function;
  selectedInboxe: any;
  managerNotifications: any;
  managers: any;
  usersInboxes: any;
  countInboxes: any;
  inboxes: any;
}

export const ManagerInboxes: React.FC<ManagerInboxesProps> = (
  props,
): JSX.Element => {
  const [filterInboxQuery, setFilterInboxQuery] = useState('');
  const getInboxesToDisplay = () => {
    let inboxes: any = props.inboxes;
    if (filterInboxQuery === '') {
      return inboxes;
    }
    const formattedFilterInboxQuery = filterInboxQuery.trim().toLowerCase();
    return inboxes.filter(
      (inbox: any) =>
        inbox.title.toLowerCase().indexOf(formattedFilterInboxQuery) !== -1,
    );
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterInboxQuery(e.target.value);
  };
  const handleSelectInbox = (el: any) => () => {
    props.setSelectedInboxe(el?.id as any);
  };
  return (
    <List style={StyledList}>
      <ListItem>
        <TextField
          name="filterInboxQuery"
          value={filterInboxQuery}
          label={translate(messages.fieldSearchInboxes, props)}
          onChange={handleChange}
          style={StyledField}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src={SearchIcon} alt="search" />
              </InputAdornment>
            ),
          }}
        />
      </ListItem>
      {getInboxesToDisplay().map((el: any) => (
        <ListItem
          style={
            props.selectedInboxe === el?.id
              ? SelectedStyledListItem
              : StyledListItem
          }
          data-testid={`Item+${el?.id}`}
          onClick={handleSelectInbox(el)}
        >
          <Grid container direction="column" spacing={2} justify="center">
            <Grid item>
              <Grid container direction="row" alignItems="center" spacing={1}>
                <Grid item>
                  <span
                    style={
                      props.selectedInboxe === el?.id
                        ? { ...StyledTitle, color: '#FFF' }
                        : StyledTitle
                    }
                  >
                    {el?.title}
                  </span>
                </Grid>
                {el.sla && (
                  <Grid item>
                    <Grid
                      style={StyledSlaContainer}
                      container
                      direction="row"
                      alignItems="center"
                    >
                      <Grid
                        item
                        style={{
                          marginTop: '3px',
                        }}
                      >
                        <img src={SlaIcon} alt="sla" />
                      </Grid>
                      <Grid
                        item
                        style={{
                          color: 'rgba(0, 117, 201, 1)',
                          fontSize: '14px',
                          marginTop: '-3px',
                          marginLeft: '2px',
                        }}
                      >
                        {'SLA: ' + el?.sla + ' j'}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={1}>
              <Grid item>
                <Grid
                  style={StyledWarningContainer}
                  container
                  direction="row"
                  alignItems="center"
                >
                  <Grid
                    item
                    style={{
                      marginTop: '3px',
                    }}
                  >
                    <img src={warning} alt="warning" />
                  </Grid>
                  <Grid
                    item
                    style={{
                      color: 'rgba(255, 140, 0, 1)',
                      fontSize: '14px',
                      marginLeft: '2px',
                    }}
                  >
                    {translate(messages.claimSubTitle, props, {
                      count: countPendingClaimsInboxe(
                        el?.type === INBOXES_TYPES.TRANSACTION
                          ? get(props.listings, 'transactionInboxeArea', [])
                          : get(props.listings, 'managerNotificationType', []),
                        el?.id,
                        get(props.countInboxes, 'countNotRead', []),
                        el?.type === INBOXES_TYPES.TRANSACTION,
                      ),
                    }) +
                      ' ' +
                      countTimeInboxes(
                        el?.type === INBOXES_TYPES.TRANSACTION
                          ? get(props.listings, 'transactionInboxeArea', [])
                          : get(props.listings, 'managerNotificationType', []),
                        el?.id,
                        get(
                          props.countInboxes,
                          'minNotReadNotitifications',
                          [],
                        ),
                        el?.type === INBOXES_TYPES.TRANSACTION,
                      )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  style={StylePendingContainer}
                  container
                  direction="row"
                  alignItems="center"
                >
                  <Grid
                    item
                    style={{
                      marginTop: '3px',
                    }}
                  >
                    <img src={timerDot} alt="timer" />
                  </Grid>
                  <Grid
                    item
                    style={{
                      color: 'rgba(0, 117, 201, 1)',
                      fontSize: '14px',
                      marginLeft: '2px',
                    }}
                  >
                    {translate(messages.claimPendingSubTitle, props, {
                      count: countPendingClaimsInboxe(
                        el?.type === INBOXES_TYPES.TRANSACTION
                          ? get(props.listings, 'transactionInboxeArea', [])
                          : get(props.listings, 'managerNotificationType', []),
                        el?.id,
                        get(props.countInboxes, 'countPending', []),
                        el?.type === INBOXES_TYPES.TRANSACTION,
                      ),
                    }) +
                      ' ' +
                      countTimeInboxes(
                        el?.type === INBOXES_TYPES.TRANSACTION
                          ? get(props.listings, 'transactionInboxeArea', [])
                          : get(props.listings, 'managerNotificationType', []),
                        el?.id,
                        get(props.countInboxes, 'minPendingNotifications', []),
                        el?.type === INBOXES_TYPES.TRANSACTION,
                      )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  style={StyleSecondaryContainer}
                  container
                  direction="row"
                  alignItems="center"
                >
                  <Grid
                    item
                    style={{
                      marginTop: '3px',
                    }}
                  >
                    <img src={personIcon} alt="person" />
                  </Grid>
                  <Grid
                    item
                    style={{
                      color: '#727A83',
                      fontSize: '14px',
                      marginLeft: '2px',
                    }}
                  >
                    {translate(messages.managersSubTitle, props, {
                      count: countManagersInboxes(props.usersInboxes, el?.id),
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
};

export default injectIntl(ManagerInboxes);
